export default __webpack_public_path__ + "static/media/Foot_right.996487c3.svg";